export default function MultiOutlets(props: any) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none" {...props}>
            <rect x="5.99994" y="6" width="32" height="32" rx="3.84127" stroke="black" strokeWidth="2" />
            <rect
                x="10.4762"
                y="16.238"
                width="11.5238"
                height="11.5238"
                rx="1.92063"
                stroke="black"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect x="17.1984" y="24.8809" width="2.88095" height="1.92063" rx="0.960317" transform="rotate(-90 17.1984 24.8809)" fill="black" />
            <rect x="13.3571" y="24.8809" width="2.88095" height="1.92063" rx="0.960317" transform="rotate(-90 13.3571 24.8809)" fill="black" />
            <rect x="15.2778" y="18.1587" width="1.92063" height="1.92063" rx="0.480159" fill="black" />
            <rect
                x="25.8413"
                y="16.238"
                width="8.64286"
                height="2.88095"
                rx="1.44048"
                stroke="black"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <rect
                x="25.8413"
                y="23.9205"
                width="8.64286"
                height="3.84127"
                rx="0.960317"
                stroke="black"
                strokeWidth="1.6"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
